// Mock data for Comfort Home website
// This function returns translated data based on current language
import i18n from '../i18n';

export const getAutomationFeatures = () => {
  const t = i18n.t.bind(i18n);
  
  return [
    {
      id: 1,
      title: t('features.item1.title', 'Iluminación Inteligente'),
      description: t('features.item1.description', 'Control total de la iluminación de tu hogar desde cualquier lugar. Ajusta intensidad, color y crea escenas personalizadas.'),
      icon: "Lightbulb",
      image: "https://images.unsplash.com/photo-1608377205619-03a0b4c4e270",
      benefits: [
        t('features.item1.benefit1', 'Ahorro energético hasta 60%'),
        t('features.item1.benefit2', 'Control por voz'),
        t('features.item1.benefit3', 'Automatización horaria')
      ]
    },
    {
      id: 2,
      title: t('features.item2.title', 'Climatización'),
      description: t('features.item2.description', 'Mantén la temperatura perfecta en cada habitación. Sistema inteligente que aprende tus preferencias y optimiza el consumo.'),
      icon: "Thermometer",
      image: "https://images.unsplash.com/photo-1545259741-2ea3ebf61fa3",
      benefits: [
        t('features.item2.benefit1', 'Reducción de costos 40%'),
        t('features.item2.benefit2', 'Confort personalizado'),
        t('features.item2.benefit3', 'Control por zonas')
      ]
    },
    {
      id: 3,
      title: t('features.item3.title', 'Seguridad Avanzada'),
      description: t('features.item3.description', 'Protección 24/7 con cámaras inteligentes, sensores de movimiento y alertas en tiempo real a tu smartphone.'),
      icon: "Shield",
      image: "https://images.unsplash.com/photo-1496368077930-c1e31b4e5b44",
      benefits: [
        t('features.item3.benefit1', 'Monitoreo en tiempo real'),
        t('features.item3.benefit2', 'Reconocimiento facial'),
        t('features.item3.benefit3', 'Alertas instantáneas')
      ]
    },
    {
      id: 4,
      title: t('features.item4.title', 'Entretenimiento'),
      description: t('features.item4.description', 'Sistema de audio y video multihabitación. Controla toda tu experiencia de entretenimiento desde una sola app.'),
      icon: "Tv",
      image: "https://images.unsplash.com/photo-1614696131965-cc559b1ecad1",
      benefits: [
        t('features.item4.benefit1', 'Audio en toda la casa'),
        t('features.item4.benefit2', 'Streaming integrado'),
        t('features.item4.benefit3', 'Control universal')
      ]
    },
    {
      id: 5,
      title: t('features.item5.title', 'Cortinas y Persianas'),
      description: t('features.item5.description', 'Automatización de cortinas, persianas y ventanas. Programación por horarios o control manual desde tu dispositivo.'),
      icon: "Blinds",
      image: "https://images.unsplash.com/photo-1751945965597-71171ec7a458",
      benefits: [
        t('features.item5.benefit1', 'Control solar automático'),
        t('features.item5.benefit2', 'Privacidad programable'),
        t('features.item5.benefit3', 'Integración con clima')
      ]
    },
    {
      id: 6,
      title: t('features.item6.title', 'Control por Voz'),
      description: t('features.item6.description', 'Integración completa con Alexa, Google Assistant y Siri. Controla tu hogar con comandos de voz naturales.'),
      icon: "Mic",
      image: "https://images.unsplash.com/photo-1752262167753-37a0ec83f614",
      benefits: [
        t('features.item6.benefit1', 'Manos libres total'),
        t('features.item6.benefit2', 'Comandos personalizados'),
        t('features.item6.benefit3', 'Rutinas inteligentes')
      ]
    }
  ];
};

// Keep the old export for backwards compatibility but it now calls the function
export const automationFeatures = getAutomationFeatures();

export const getBenefits = () => {
  const t = i18n.t.bind(i18n);
  return [
    { id: 1, title: t('benefits.item1.title', 'Ahorro Energético'), description: t('benefits.item1.description', 'Reduce tu consumo eléctrico hasta un 60% con automatización inteligente y gestión eficiente de recursos.'), icon: "Zap", percentage: "60%" },
    { id: 2, title: t('benefits.item2.title', 'Confort Total'), description: t('benefits.item2.description', 'Ambiente perfecto en cada momento. Tu hogar se adapta automáticamente a tus necesidades y preferencias.'), icon: "Home", percentage: "100%" },
    { id: 3, title: t('benefits.item3.title', 'Seguridad Garantizada'), description: t('benefits.item3.description', 'Protección continua con monitoreo 24/7, alertas inteligentes y respuesta automática ante incidentes.'), icon: "ShieldCheck", percentage: "24/7" },
    { id: 4, title: t('benefits.item4.title', 'Valorización'), description: t('benefits.item4.description', 'Incrementa el valor de tu propiedad hasta un 20% con tecnología de automatización de última generación.'), icon: "TrendingUp", percentage: "+20%" }
  ];
};
export const benefits = getBenefits();

export const getSolutions = () => {
  const t = i18n.t.bind(i18n);
  return [
    { id: 1, category: t('solutions.item1.category', 'RESIDENCIAL'), title: t('solutions.item1.title', 'Casas y Departamentos'), description: t('solutions.item1.description', 'Soluciones completas para espacios residenciales. Desde estudios hasta residencias de lujo.'), features: [t('solutions.item1.feature1', 'Paquetes personalizables'), t('solutions.item1.feature2', 'Instalación profesional'), t('solutions.item1.feature3', 'Garantía extendida')], icon: "Building" },
    { id: 2, category: t('solutions.item2.category', 'EMPRESARIAL'), title: t('solutions.item2.title', 'Oficinas y Comercios'), description: t('solutions.item2.description', 'Automatización para espacios comerciales que optimiza costos y mejora la experiencia del cliente.'), features: [t('solutions.item2.feature1', 'Control centralizado'), t('solutions.item2.feature2', 'Gestión energética'), t('solutions.item2.feature3', 'Seguridad corporativa')], icon: "Briefcase" },
    { id: 3, category: t('solutions.item3.category', 'HOTELERÍA'), title: t('solutions.item3.title', 'Hoteles y Resorts'), description: t('solutions.item3.description', 'Experiencia premium para huéspedes con control total desde habitaciones hasta áreas comunes.'), features: [t('solutions.item3.feature1', 'Check-in inteligente'), t('solutions.item3.feature2', 'Personalización por huésped'), t('solutions.item3.feature3', 'Gestión masiva')], icon: "Hotel" }
  ];
};
export const solutions = getSolutions();

export const testimonials = [
  {
    id: 1,
    name: "María González",
    role: "Propietaria",
    content: "Comfort Home transformó completamente mi departamento. Ahora controlo todo desde mi teléfono y mi factura de luz bajó un 50%. ¡Increíble!",
    rating: 5,
    image: "https://i.pravatar.cc/150?img=1"
  },
  {
    id: 2,
    name: "Carlos Rodríguez",
    role: "Arquitecto",
    content: "Como arquitecto, aprecio la calidad de la instalación y el diseño integrado. El equipo de Comfort Home es extremadamente profesional.",
    rating: 5,
    image: "https://i.pravatar.cc/150?img=13"
  },
  {
    id: 3,
    name: "Laura Martínez",
    role: "Empresaria",
    content: "La seguridad y el control remoto me dan tranquilidad cuando viajo. El sistema nunca ha fallado. 100% recomendado.",
    rating: 5,
    image: "https://i.pravatar.cc/150?img=5"
  }
];

export const projects = [
  {
    id: 1,
    title: "Residencia Moderna en Polanco",
    type: "Residencial",
    description: "Automatización completa de villa de 450m² con más de 80 dispositivos integrados.",
    image: "https://images.unsplash.com/photo-1751945965597-71171ec7a458",
    devices: 80
  },
  {
    id: 2,
    title: "Departamento Inteligente",
    type: "Residencial",
    description: "Transformación de departamento de 120m² con enfoque en eficiencia energética.",
    image: "https://images.unsplash.com/photo-1717323454555-f053c31ff4b4",
    devices: 35
  },
  {
    id: 3,
    title: "Oficinas Corporativas",
    type: "Empresarial",
    description: "Sistema de automatización para 5 pisos de oficinas con 200+ empleados.",
    image: "https://images.unsplash.com/photo-1614696131965-cc559b1ecad1",
    devices: 150
  },
  {
    id: 4,
    title: "Boutique Hotel",
    type: "Hotelería",
    description: "Automatización de 40 habitaciones con control centralizado y experiencias personalizadas.",
    image: "https://images.pexels.com/photos/29292011/pexels-photo-29292011.jpeg",
    devices: 200
  }
];

export const getFaqData = () => {
  const t = i18n.t.bind(i18n);
  return [
    { id: "faq-1", question: t('faq.q1.question'), answer: t('faq.q1.answer') },
    { id: "faq-2", question: t('faq.q2.question'), answer: t('faq.q2.answer') },
    { id: "faq-3", question: t('faq.q3.question'), answer: t('faq.q3.answer') },
    { id: "faq-4", question: t('faq.q4.question'), answer: t('faq.q4.answer') },
    { id: "faq-5", question: t('faq.q5.question'), answer: t('faq.q5.answer') }
  ];
};
export const faqData = getFaqData();

export const contactInfo = {
  phone: "+52 5555068008",
  email: "contacto@comforthome.mx",
  hours: "Lunes a Viernes: 9:00 AM - 6:00 PM",
  social: {
    facebook: "#",
    instagram: "#",
    linkedin: "#",
    twitter: "#"
  }
};
